import { render, staticRenderFns } from "./DailyWatch.vue.vue?vue&type=template&id=604094b8&"
import script from "./DailyWatch.vue.vue?vue&type=script&lang=js&"
export * from "./DailyWatch.vue.vue?vue&type=script&lang=js&"
import style0 from "./DailyWatch.vue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports